var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlpAuthenticator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 36,
    fill: "#FF4E10"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.7483 52.6966H78.6414V43.3459C78.6414 38.3526 76.7024 33.6573 73.1802 30.122C69.7118 26.6409 64.9054 24.6445 59.9987 24.6445C55.0891 24.6445 50.2827 26.6409 46.8144 30.122C43.295 33.6544 41.3559 38.3516 41.3559 43.3459V52.6966H38.2491C33.1086 52.6966 28.9277 56.8907 28.9277 62.0473V83.8653C28.9277 89.0219 33.1086 93.216 38.2491 93.216H81.7492C86.8897 93.216 91.0706 89.0219 91.0706 83.8653V62.0473C91.0696 56.8916 86.8887 52.6966 81.7483 52.6966ZM47.5705 43.3459C47.5705 40.0157 48.8632 36.884 51.2082 34.5297C53.5201 32.2086 56.7244 30.8786 59.9987 30.8786C63.2692 30.8786 66.4735 32.2086 68.7863 34.5297C71.1351 36.8868 72.4278 40.0176 72.4278 43.3459V52.6966H47.5705V43.3459ZM58.706 81.66L44.6463 81.7369C42.5133 81.7483 41.1761 79.4301 42.2483 77.5808L49.2124 65.5721C50.2685 63.7504 52.887 63.7361 53.963 65.5465L61.0576 77.4783C62.1516 79.3152 60.839 81.6486 58.706 81.66ZM77.7339 68.4362L70.6393 80.368C69.5633 82.1774 66.9448 82.1632 65.8887 80.3424L58.9246 68.3336C57.8524 66.4844 59.1896 64.1662 61.3226 64.1776L75.3823 64.2544C77.5144 64.2649 78.826 66.5983 77.7339 68.4362Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpAuthenticator);
export default __webpack_public_path__ + "static/media/alp_authenticator.e25f6c24747fbd1584feee5405bb41d9.svg";
export { ForwardRef as ReactComponent };